

/****************************************************************************

  Generated by const.tst - please don't make any changes in this file

****************************************************************************/


    /** Generated from NBWebCGA.Web.ClientApp.CommonData.DomainCodes **/
	export const DomainCodes = { 
		domains: 'Domains',
		genders: 'C_Gender',
		wfState: 'C_States',
		identificationType: 'C_IdentificationDoc',
		nationality: 'C_Nationality',
		martialStatus: 'C_MaritalStatus',
		country: 'C_Country',
		phonePrefix: 'C_PhonePrefix',
		mobilePhonePrefix: 'C_MobilePhonePrefix',
		quotaValue: 'C_QuoteValue',
		professionalCategory: 'C_ProfessionalCategory',
		workAssigment: 'C_WorkAssigment',
		fiscalCategories: 'C_FiscalCategories',
		incomeHolding: 'C_IncomeHolding',
		subscriberType: 'C_SubscriberType',
		yesNo: 'C_YesNo',
		bankAccountTypes: 'C_BankAcountType',
		subscriberSituations: 'C_SubscriberSituation',
		scheduleTypes: 'C_ScheduleType',
		remunerationTypes: 'C_RenumerationType',
		benefitTypes: 'C_BenefitTypes',
		subBenefitTypes: 'C_BenefitSubTypes',
		fileTypes: 'C_FileTypes',
		reflectionDeadlines: 'C_ReflectionDeadlines',
		limitAgesByProfCategory: 'C_LimitAgesByProfCategory',
		scheduleRegimen: 'C_ScheduleRegimen',
		revenueTitularity: 'C_RevenueTitularity',
		documentDesignationType: 'C_DocumentType',
		instanceBrowserStatus: 'C_InstanceBrowerStatus',
		videoCallLocations: 'C_VideoCallLocations',
    studyLevel: 'C_StudyLevel',

	}


